/**
 * @generated SignedSource<<8e4e6b16435221ba025d385ac47f9410>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TwoFactorConfigureRecoveryCodes_recoveryCodes$data = {
  readonly codes: ReadonlyArray<{
    readonly code: string;
    readonly consumed: boolean;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"RecoveryCodeList_recoveryCodes">;
  readonly " $fragmentType": "TwoFactorConfigureRecoveryCodes_recoveryCodes";
};
export type TwoFactorConfigureRecoveryCodes_recoveryCodes$key = {
  readonly " $data"?: TwoFactorConfigureRecoveryCodes_recoveryCodes$data;
  readonly " $fragmentSpreads": FragmentRefs<"TwoFactorConfigureRecoveryCodes_recoveryCodes">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TwoFactorConfigureRecoveryCodes_recoveryCodes",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecoveryCodeList_recoveryCodes"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecoveryCode",
      "kind": "LinkedField",
      "name": "codes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "consumed",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecoveryCodeBatch",
  "abstractKey": null
};

(node as any).hash = "027bc22cb8556318655444315544c0e5";

export default node;
